// import logoo from "../assets/logo/imdady_logo.png";
import { BsPersonVcard } from "react-icons/bs";
import { AiOutlineDashboard } from "react-icons/ai";
import { CiSettings } from "react-icons/ci";
import { IoHomeOutline } from "react-icons/io5";
import { FiTruck } from "react-icons/fi";
import { FaRegFile } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";
import { IoMdDesktop } from "react-icons/io";
import { FaRegWindowRestore } from "react-icons/fa6";
import { BsUniversalAccessCircle } from "react-icons/bs";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { LiaComments } from "react-icons/lia";
import { IoPricetagsOutline } from "react-icons/io5";
import { FaRegTrashCan } from "react-icons/fa6";
import { PiUsersThreeLight } from "react-icons/pi";
import { LiaTasksSolid } from "react-icons/lia";
// import { GoDot } from "react-icons/go";
import { PiForkKnife } from "react-icons/pi";
// import SidenavItem from "./SidenavItem";
import { languageHelper } from "../../config/helperFunctions";
import SidenavDesktop from "./SidenavDesktop";
import SidenavMobile from "./SidenavMobile";

export default function SidenavNew({ logo }) {
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  const Menus = [
    {
      title: "Home",
      label: languageHelper(defaultLang, "home"),
      icon: <IoHomeOutline className="text-2xl block float-left" />,
      link: "home",
    },
    {
      title: "Dashboard",
      label: languageHelper(defaultLang, "Dashboard"),
      icon: <AiOutlineDashboard className="text-2xl block float-left" />,
      link: "dashboard",
      // commingSoon: true,
    },
    {
      title: "Setting",
      label: languageHelper(defaultLang, "Setting"),
      icon: <CiSettings className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Setting",
          label: languageHelper(defaultLang, "Setting"),
          link: "setting",
        },
        {
          title: "Language",
          label: languageHelper(defaultLang, "language"),
          link: "language",
        },
      ],
    },
    {
      title: "Items",
      label: languageHelper(defaultLang, "Items"),
      submenu: true,
      icon: <PiForkKnife className="text-2xl block float-left" />,
      submenuItems: [
        {
          title: "Main Categories",
          label: languageHelper(defaultLang, "Main Categories"),
          link: "foodMenuCategories",
        },
        {
          title: "Sub Categories",
          label: languageHelper(defaultLang, "Sub Categories"),
          link: "foodMenuSubCategories",
        },
        {
          title: "Items",
          label: languageHelper(defaultLang, "Items"),
          link: "foodMenus",
        },
        {
          title: "Add Ons",
          label: languageHelper(defaultLang, "Add Ons"),
          link: "modifiers",
        },
        {
          title: "Deals",
          label: languageHelper(defaultLang, "Deals"),
          link: "deals",
        },
        {
          title: "VATs",
          label: languageHelper(defaultLang, "VATs"),
          link: "VATs",
        },
        {
          title: "Ingredient Categories",
          label: languageHelper(defaultLang, "Ingredient Categories"),
          link: "ingredientCategory",
        },
        {
          title: "Ingredients",
          label: languageHelper(defaultLang, "Ingredients"),
          link: "ingredients",
        },
        {
          title: "Ingredient Units",
          label: languageHelper(defaultLang, "Ingredient Units"),
          link: "units",
        },
      ],
    },
    {
      title: "Management",
      label: languageHelper(defaultLang, "Management"),
      icon: <BsPersonVcard className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Subscriptions Management",
          label: languageHelper(defaultLang, "Subscriptions Management"),
          link: "subscription-managment",
          // commingSoon: true,
        },
        {
          title: "Printer",
          label: languageHelper(defaultLang, "Printer"),
          link: "printer",
        },
        {
          title: "Tables",
          label: languageHelper(defaultLang, "Tables"),
          link: "tables",
        },
        {
          title: "Return",
          label: languageHelper(defaultLang, "Return"),
          link: "return",
        },
        {
          title: "Deposit",
          label: languageHelper(defaultLang, "Deposit"),
          link: "deposite",
          commingSoon: true,
        },
        {
          title: "Copy Items",
          label: languageHelper(defaultLang, "Copy Items"),
          link: "copy-items",
          commingSoon: true,
        },
        {
          title: "Clean database",
          label: languageHelper(defaultLang, "Clean Database"),
          link: "cleanDatabase",
          commingSoon: true,
        },
      ],
    },
    {
      title: "Delivery",
      label: languageHelper(defaultLang, "Delivery"),
      icon: <FiTruck className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Rider Order",
          label: languageHelper(defaultLang, "Rider Order"),
          link: "listorder",
          commingSoon: true,
        },
      ],
    },
    {
      title: "Outlet",
      label: languageHelper(defaultLang, "Outlet"),
      icon: <CiSettings className="text-2xl block float-left" />,
      link: "outlet",
      // commingSoon: true,
    },
    {
      title: "Reporting",
      label: languageHelper(defaultLang, "Reporting"),
      icon: <FaRegFile className="text-2xl block float-left" />,
      link: "reporting",
      // commingSoon: true,
    },
    {
      title: "All Sales",
      label: languageHelper(defaultLang, "All Sales"),
      icon: <FaChartLine className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "POS Sales",
          label: languageHelper(defaultLang, "POS Sales"),
          link: "allsales",
        },
        {
          title: "Online Sales",
          label: languageHelper(defaultLang, "Online Sales"),
          link: "weborder",
        },
      ],
    },
    {
      title: "Screens",
      label: languageHelper(defaultLang, "Screens"),
      icon: <IoMdDesktop className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "POS",
          label: languageHelper(defaultLang, "pos"),
          link: "/POS/main",
        },
        {
          title: "Kitchen",
          label: languageHelper(defaultLang, "Kitchen"),
          link: "kitchen",
          commingSoon: true,
        },
        // { title: "Bar", link: "barPanel" },
        {
          title: "Waiter",
          label: languageHelper(defaultLang, "Waiter"),
          link: "waiter",
          commingSoon: true,
        },
      ],
    },
    {
      title: "E-Commerce",
      label: languageHelper(defaultLang, "E-Commerce"),
      icon: <FaRegWindowRestore className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Sms Module",
          label: languageHelper(defaultLang, "Sms Module"),
          link: "smsMobile",
          commingSoon: true,
        },
        {
          title: "Payment Gateway",
          label: languageHelper(defaultLang, "Payment Gateway"),
          link: "paymentGateway",
          commingSoon: true,
        },
        {
          title: "Banners",
          label: languageHelper(defaultLang, "Banners"),
          link: "bannersetting",
        },
        {
          title: "Top Banner",
          label: languageHelper(defaultLang, "Top Banner"),
          link: "topbanner",
        },
        {
          title: "Qrcode",
          label: languageHelper(defaultLang, "Qrcode"),
          link: "qrCode",
        },
        {
          title: "Order Type",
          label: languageHelper(defaultLang, "Order Type"),
          link: "ordertype",
        },
        {
          title: "Web Setting",
          label: languageHelper(defaultLang, "Web Setting"),
          link: "webSetting",
          // commingSoon: true,
        },
        {
          title: "Mail Config",
          label: languageHelper(defaultLang, "Mail Config"),
          link: "mailConfig",
          commingSoon: true,
        },
        {
          title: "Social Media",
          label: languageHelper(defaultLang, "Social Media"),
          link: "socialmedia",
          commingSoon: true,
        },
      ],
    },
    {
      title: "Accounting",
      label: languageHelper(defaultLang, "Accounting"),
      icon: <BsUniversalAccessCircle className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Setup",
          label: languageHelper(defaultLang, "Setup"),
          link: "setup",
          commingSoon: true,
        },
      ],
    },
    {
      title: "Promotion",
      label: languageHelper(defaultLang, "Promotion"),
      icon: <FaRegMoneyBillAlt className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Coupon",
          label: languageHelper(defaultLang, "Coupon"),
          link: "coupon",
        },
        {
          title: "Credit Card",
          label: languageHelper(defaultLang, "Credit Card"),
          link: "creditCard",
        },
        {
          title: "Subscriptions",
          label: languageHelper(defaultLang, "Subscriptions"),
          link: "subscription",
          // commingSoon: true,
        },
        {
          title: "Loyalty",
          label: languageHelper(defaultLang, "Loyalty"),
          link: "loyalty",
        },
        {
          title: "Product discount",
          label: languageHelper(defaultLang, "Product Discount"),
          link: "productdiscount",
        },
        {
          title: "Category discount",
          label: languageHelper(defaultLang, "Category Discount"),
          link: "categorydiscount",
        },
        {
          title: "Category Schedule",
          label: languageHelper(defaultLang, "Category Schedule"),
          link: "categorySchedule",
        },
      ],
    },
    {
      title: "Customer Feedback",
      label: languageHelper(defaultLang, "Customer Feedback"),
      icon: <HiOutlinePencilSquare className="text-2xl block float-left" />,
      link: "customer-feedback",
      commingSoon: true,
    },
    {
      title: "Feedback",
      label: languageHelper(defaultLang, "Feedback"),
      icon: <LiaComments className="text-2xl block float-left" />,
      link: "feedback",
      commingSoon: true,
    },
    {
      title: "Purchase",
      label: languageHelper(defaultLang, "Purchase"),
      icon: <IoPricetagsOutline className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Add Purchase",
          label: languageHelper(defaultLang, "Add Purchase"),
          link: "purchase",
        },
        {
          title: "Inventory",
          label: languageHelper(defaultLang, "Inventory"),
          link: "inventory",
          commingSoon: true,
        },
        {
          title: "Inventory Adjustments",
          label: languageHelper(defaultLang, "Inventory Adjustments"),
          link: "inventoryAdjustment",
          commingSoon: true,
        },
        {
          title: "Expense Category",
          label: languageHelper(defaultLang, "Expense Category"),
          link: "expensescategory",
        },
        {
          title: "Expense",
          label: languageHelper(defaultLang, "Expense"),
          link: "expenses",
        },
      ],
    },
    {
      title: "Waste",
      label: languageHelper(defaultLang, "Waste"),
      icon: <FaRegTrashCan className="text-2xl block float-left" />,
      link: "waste",
      commingSoon: true,
    },
    {
      title: "User Section",
      label: languageHelper(defaultLang, "User Section"),
      icon: <PiUsersThreeLight className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Companies",
          label: languageHelper(defaultLang, "Companies"),
          link: "companies",
          commingSoon: true,
        },
        {
          title: "Suppliers",
          label: languageHelper(defaultLang, "Suppliers"),
          link: "suppliers",
        },
        {
          title: "Vendor",
          label: languageHelper(defaultLang, "Vendor"),
          link: "vendor",
        },
        {
          title: "Customers",
          label: languageHelper(defaultLang, "Customers"),
          link: "customer",
        },
        // { title: "Supplier Due Payment", link: "supplierPayment" },
        // { title: "Customer Due Receive", link: "customerReceive" },
        // { title: "Attendance", link: "attendance" },
      ],
    },
    {
      title: "Role Management",
      label: languageHelper(defaultLang, "Role Management"),
      icon: <LiaTasksSolid className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "General Settings",
          label: languageHelper(defaultLang, "General Settings"),
          link: "generalSetting",
          commingSoon: true,
        },
        {
          title: "User Management",
          label: languageHelper(defaultLang, "User Management"),
          link: "manageUser",
        },
      ],
    },
  ];

  return (
    <>
      {/* {isMobileOpen ? ( */}
      <div className="lg:hidden">
        <SidenavMobile Menus={Menus} logo={logo} />
      </div>
      {/* ) : ( */}
      <div className="hidden lg:block">
        <SidenavDesktop Menus={Menus} logo={logo} />
        {/* )} */}
      </div>
    </>
  );
}
